export const formatTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  if (sameDay) return time;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (d.toDateString() === yesterday.toDateString()) return `Yesterday ${time}`;
  return `${d.toLocaleDateString([], { month: 'short', day: 'numeric' })} ${time}`;
};

export const formatDuration = (seconds) => {
  const s = Math.max(0, Math.round(seconds || 0));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

export const formatBytes = (bytes) => {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

export const isImage = (info) => Boolean(info?.content_type?.startsWith('image/'));

export const previewText = (msg) => {
  if (!msg) return '';
  if (msg.message_type === 'voice') return msg.transcript || 'Voice message';
  if (msg.message_type === 'file') return isImage(msg.file_info) ? 'Photo' : msg.file_info?.filename || 'File';
  return msg.message || '';
};

export const initials = (name = '') =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('') || '?';

// Conversation keys: "team:<teamId>" for channels, "user:<peerId>" for 1:1.
export const conversationKeyFor = (msg, myId) => {
  if (msg.team_id) return `team:${msg.team_id}`;
  const peer = msg.from_user_id === myId ? msg.to_user_id : msg.from_user_id;
  return `user:${peer}`;
};

export const splitKey = (key = '') => {
  const idx = key.indexOf(':');
  return idx === -1 ? [null, null] : [key.slice(0, idx), key.slice(idx + 1)];
};
